<div class="photo-side-by-side-modal">
  <div class="modal-header d-flex align-items-center p-3 bg-primary text-white">
    <div class="flex-grow-1 text-center">
      <h3 class="mb-0">Comparación de Archivos de Identificación</h3>
    </div>
    <button mat-icon-button (click)="close()" class="text-white close-header-button" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body p-4">
    <div *ngIf="loading" class="text-center py-5">
      <mat-spinner diameter="50" class="mx-auto"></mat-spinner>
      <p class="mt-3">Cargando imágenes...</p>
    </div>

    <div *ngIf="error && !loading" class="alert alert-warning text-center">
      <mat-icon>warning</mat-icon>
      <p class="mb-0 mt-2">{{ error }}</p>
    </div>

    <div *ngIf="!loading && !error" class="photos-container">
      <div class="row g-4">
        <!-- Foto del Perfil -->
        <div class="col-md-6">
          <div class="photo-card h-100">
            <div class="photo-header bg-light p-3 border-bottom">
              <h5 class="mb-0 text-primary">
                <mat-icon class="me-2">person</mat-icon>
                Archivo del Perfil
              </h5>
            </div>
            <div class="photo-content p-3">
              <div *ngIf="photoIdUrl && !isPhotoIdPdf" class="image-wrapper">
                <img
                  [src]="photoIdUrl"
                  alt="Foto de Identificación del Perfil"
                  class="img-fluid rounded shadow-sm"
                  (error)="onImageError('photoId')"
                  loading="lazy">
              </div>
              <div *ngIf="photoIdUrl && isPhotoIdPdf" class="pdf-wrapper">
                <ngx-extended-pdf-viewer
                  [src]="photoIdUrl"
                  [useBrowserLocale]="true"
                  [showSidebarButton]="true"
                  [showFindButton]="true"
                  [showZoomButtons]="true"
                  [showPagingButtons]="true"
                  [showPresentationModeButton]="true"
                  [showOpenFileButton]="false"
                  [showPrintButton]="true"
                  [showDownloadButton]="true"
                  [showBookmarkButton]="true"
                  [showSecondaryToolbarButton]="true"
                  [height]="'800px'">
                </ngx-extended-pdf-viewer>
              </div>
              <div *ngIf="!photoIdUrl" class="no-image-placeholder">
                <mat-icon class="large-icon">image_not_supported</mat-icon>
                <p class="text-muted mt-2">No hay archivo disponible</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Foto del Requisito -->
        <div class="col-md-6">
          <div class="photo-card h-100">
            <div class="photo-header bg-light p-3 border-bottom">
              <h5 class="mb-0 text-primary">
                <mat-icon class="me-2">description</mat-icon>
                Archivo del Requisito
              </h5>
            </div>
            <div class="photo-content p-3">
              <div *ngIf="fileIdUrl && !isFileIdPdf" class="image-wrapper">
                <img
                  [src]="fileIdUrl"
                  alt="Foto de Identificación del Requisito"
                  class="img-fluid rounded shadow-sm"
                  (error)="onImageError('fileId')"
                  loading="lazy">
              </div>
              <div *ngIf="fileIdUrl && isFileIdPdf" class="pdf-wrapper">
                <ngx-extended-pdf-viewer
                  [src]="fileIdUrl"
                  [useBrowserLocale]="true"
                  [showSidebarButton]="true"
                  [showFindButton]="true"
                  [showZoomButtons]="true"
                  [showPagingButtons]="true"
                  [showPresentationModeButton]="true"
                  [showOpenFileButton]="false"
                  [showPrintButton]="true"
                  [showDownloadButton]="true"
                  [showBookmarkButton]="true"
                  [showSecondaryToolbarButton]="true"
                  [height]="'800px'">
                </ngx-extended-pdf-viewer>
              </div>
              <div *ngIf="!fileIdUrl" class="no-image-placeholder">
                <mat-icon class="large-icon">image_not_supported</mat-icon>
                <p class="text-muted mt-2">No hay archivo disponible</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer p-3 bg-light border-top d-flex justify-content-end">
    <button mat-raised-button color="primary" (click)="close()" type="button" class="close-button">
      Cerrar
    </button>
  </div>
</div>

